<template>
  <!--MODAL BODY-->
  <div class="modalCar" @click="close" v-if="carrito.items">
    <!--MODAL CONTAINER-->
    <div class="modalc" @click.stop>
      <div class="carr-b" v-if="added">
        <!--TITLE-->
        <div class="tlc">
          <p class="title">AÑADIDO A LA CESTA</p>
          <img src="../../assets/cross.svg" alt="cross" class="cross" @click="close" />
        </div>
        <div class="dflx proinfo">
          <img :src="url + '/product-img/' + added.image" alt="product" class="prod" v-if="added.image !== ''" />
          <img src="../../assets/noimg.png" alt="product" class="prod" v-else />
          <section>
            <p class="price">${{ (added.price * added.cantidad).toFixed(2) }}</p>
            <p class="tl">
              {{ added.name }}
            </p>
            <div class="dflx jcsb pesocan">
              <p v-for="(c, i) in added.atributosFilt" :key="i" v-if="c.atributo == 'PESO'">
                {{ c.sel }}
              </p>
              <p>x{{ added.cantidad }}</p>
            </div>
          </section>
        </div>
        <div class="btn-fc" @click="toCheckout()">TRAMITAR PEDIDO</div>
        <div class="verCst cp" @click="gotobasket()">
          Ver cesta ({{ carrito.items[datal].cantidad }})
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { url, endpointCodes } from "../../global/index";
export default {
  data() {
    return {
      url: url,
      endpointCodes,
      acta: false,
      datal: 0,
    };
  },
  async created() {
    await this.obtenerCarritos();
    await this.getIdentity();
    this.datal = this.carrito.items.length == 0 ? 0 : this.carrito.items.length - 1;
  },
  computed: {
    added() {
      return this.$store.getters["carrito/getAdded"];
    },
    carrito() {
      return this.$store.getters["carrito/getcar"];
    },
    update() {
      let data = this.$store.getters["carrito/getupd"];

      if (Array.isArray(data.items)) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].cantidad != this.carrito.items[i].cantidad) {
            this.upd = true;
            break;
          } else {
            this.upd = false;
          }
        }
      }
      return data;
    },
    identity() {
      return this.$store.getters["admin/getIdentity"];
    },
  },
  methods: {
    ...mapActions("carrito", ["getCart"]),
    ...mapActions("carrito", ["getCartCopy"]),
    ...mapActions("carrito", ["setAddedCrt"]),
    ...mapActions("carrito", ["setAddedCrt2"]),
    close: async function () {
      /*window.history.go(-1); *///Regresar a la página
      this.$emit("close");
      let payload3 = {
        mdc: 'none',
      }
      await this.setAddedCrt2(payload3)
    },
    gotobasket: async function () {
      /*window.history.go(-1); //Regresar a la página*/
      this.$emit("close");
      let payload3 = {
        mdc: 'mdc',
      }
      await this.setAddedCrt2(payload3)
      /*setTimeout(() => {
      }, 2000); */
    },
    async obtenerCarritos() {
      await this.getCart();
      await this.getCartCopy();
    },
    getIdentity: async function () {
      let response = await this.$store.dispatch("admin/getData");
      return response;
    },

    toCheckout: async function () {
      //await this.obtenerCarritos();
      let payload = {
        carrito: this.carrito,
      };
      let result = await this.$store.dispatch("carrito/validateCrt", {
        option: "valid_cart",
        item: payload,
      });

      if (result.status == "error") {
        this.status = "error";
        this.message = result.message; // result.message;
        //this.delStatus();
      } else {
        // success
        //si todo esta correcto redireccionar.
        localStorage.getItem("lastv");
        localStorage.setItem("lastv", "car");
        localStorage.setItem("linked", "pro");
        //window.scrollTo(0, 0);
        this.$router.push("/check-out").catch((err) => { });
        return window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      }
    },

    getAttr(c) {
      let attr = c.item.product_atributo_valores;
      if (!attr) return "";

      if (!Array.isArray(attr) || attr.length == 0) return "";

      if (!attr[0].valor || !attr[0].atributo) return "";

      return " (" + attr[0].valor + " " + attr[0].atributo + ")";
    },
    actualizarCarrito: async function (carrito, key) {
      let payload = {
        carrito,
      };
      let result = await this.$store.dispatch("carrito/editItemCrt", {
        option: "upt_item",
        item: payload,
      });

      if (result.status == "error") {
        this.status = "error";
        this.message =
          "Ha ocurrido un error al intentar actualizar el carrito."; // result.message;
      } else {
        // success

        await this.obtenerCarritos();
        this.status = "success";
        this.message = "Carrito actualizado";
        this.acta = false;
        if (this.update.items.length == 0) {
          this.close();
        }
      }
    },
    reload() {
      window.history.go(-1);
    },
  },
};
</script>
<style scoped>
.eventBlock {
  pointer-events: none;
  opacity: 0.5;
}

.modalCar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}

.modalCar .modalc {
  background: #fff9ea;
  height: 100vh;
  width: 100%;
}

.modalCar .carr-b {
  padding: 9.662vw 5.556vw 5.556vw;
}

.modalCar .tlc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid transparent;
  padding-bottom: 0;
  margin-bottom: 13.043vw;
}

.modalCar .tlc .title {
  margin: 0;
  font-weight: 700;
  font-size: 4.831vw;
  line-height: 111%;
  color: var(--co-tlMCar);
  font-family: var(--font-tlMCar);
}

.modalCar .tlc .cross {
  width: 8.696vw;
  height: 8.696vw;
}

.modalCar .tlc .title span {
  margin-left: 5.072vw;
  padding: 2.415vw 4.348vw;
  background-color: var(--bk-cantMCar);
  color: var(--co-cantMCar);
  border-radius: 10vw;
}

.modalCar .proinfo .prod {
  width: 20.773vw;
  height: 20.773vw;
}

.modalCar .proinfo section {
  width: 60.386vw;
  padding-left: 4.106vw;
}

.modalCar .proinfo .tl {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 5.556vw;
  line-height: 111%;
  color: var(--co-ptlMCar);
  font-family: var(--font-ptlMCar);
  margin: 0;
}

.modalCar .btn-fc {
  width: 49.517vw;
  height: 12.319vw;
  border: 2px solid var(--b-fcMCar);
  background: transparent;
  color: var(--co-fcMCar);
  font-family: var(--font-tlMCar);
  border-radius: 9.662vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 3.382vw;
  line-height: 111%;
  margin: auto;
  cursor: pointer;
  transition: .5s;
}
.modalCar .btn-fc:hover {
    background-color: var(--co-ptlMCar);
    color: #fff9ea;
}

.verCst {
  width: fit-content;
  margin: auto;
  font-family: var(--font-tlMCar);
  font-weight: 700;
  font-size: 0.729vw;
  line-height: 188%;
  color: var(--co-txtcMCar);
}

@media (max-width: 769px) {
  .modalCar .btn-fc.yll {
    width: 35.024vw;
  }
}

@media (min-width: 768px) {
  .modalCar {
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: rgba(150, 150, 150, 0.8);
  }

  .modalCar .modalc {
    width: 20.833vw;
    border: 0.104vw solid #ff3723;
    margin-left: auto;
    position: relative;
    right: -40vw;
    transition: 0.75s;
    height: fit-content;
  }

  .modalCar.transitionL .modalc {
    right: 0;
  }

  .modalCar .carr-b {
    padding: 1.25vw 1.042vw;
  }

  .modalCar .tlc {
    padding-bottom: 1.25vw;
    margin-bottom: 0;
  }

  .modalCar .tlc .title,
  .modalCar .proinfo .tl {
    font-size: 0.521vw;
  }

  .modalCar .proinfo .price {
    font-weight: 700;
    font-size: 1.042vw;
    line-height: 1.927vw;
    color: #ff3723;
    margin: 0;
    font-family: "Kinetica-Bold";
  }

  .modalCar .tlc .title::before {
    content: "*";
    font-family: "Catou";
    font-weight: 300;
    color: #194c06;
    font-size: 3vw;
    position: relative;
    top: 1.34vw;
    margin: 0 0.7vw 0 0;
  }

  .modalCar .tlc .title span {
    padding: 0.521vw 0.938vw;
    margin-left: 1.094vw;
  }

  .modalCar .tlc .cross {
    width: 1.696vw;
    height: 1.696vw;
    cursor: pointer;
  }

  .modalCar .proinfo {
    border: 0.104vw solid #ff3723;
    padding: 0.729vw;
  }

  .modalCar .proinfo .prod {
    width: 4.479vw;
    height: 4.479vw;
  }

  .modalCar .proinfo .sbtl {
    font-size: 0.729vw;
  }

  .modalCar .proinfo section {
    width: 15.521vw;
    padding-left: 0.885vw;
  }

  .modalCar .c-p-cont .price {
    font-size: 0.938vw;
    width: 4.324vw;
    height: 2.061vw;
  }

  .modalCar .prod-list.scroll {
    overflow-y: scroll;
  }

  .modalCar .prod-list {
    height: 61.11111111111111vh;
    padding-bottom: 0;
    border-bottom: 0.1vw solid gainsboro;
    /*overflow-y: scroll;*/
  }

  .modalCar .product-c {
    padding-bottom: 3.021vw;
    padding-left: 1vw;
    padding-right: 1vw;
    border-bottom: 0.1vw solid gainsboro;
    margin-bottom: 3.021vw;
  }

  .modalCar .product-c:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .modalCar .subt-c span {
    font-size: 1.563vw;
  }

  .modalCar .subt-c p {
    padding: 1.302vw 0 1.667vw;
  }

  .modalCar .btn-fc {
    width: 12.188vw;
    height: 2.656vw;
    font-size: 0.625vw;
    margin-top: 1.719vw;
    margin-bottom: 0.885vw;
  }

  .pesocan {
    margin-top: 0.729vw;
  }

  .pesocan p {
    font-family: "Kinetica-Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 0.521vw;
    line-height: 0.938vw;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #ff3723;
    margin: 0;
  }
}</style>
